var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":"您不是管理员，请使用管理员账号登录","ok-text":"重新登录","visible":_vm.visible}},[_c('template',{slot:"footer"},[_c('a-button',{on:{"click":_vm.reLogin}},[_vm._v("重新登录")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }